import HeadModel from "./components/HeadModel";

import './styles/globals.scss';

function App() {
  return (
    <div>
      <main>
        <HeadModel modelPath="/assets/head.glb" />
      </main>
      <footer className="footer position-absolute bottom-0 start-50 translate-middle-x">
        <a href="https://www.fab.com/listings/446d0e45-1048-4403-a28f-0e3bdcfd3152" >
          Head Credit
        </a>
        <a href="https://duncan.ie" >
          &copy; Duncan {new Date().getFullYear()}
        </a>
      </footer>
    </div>
  );
}

export default App;
